import React from 'react'
import { useState, useEffect } from 'react'
import '../styles/ColorContrast.css'
import useContrastRatio from '../hooks/useContrastRatio'

const ColorContrast = () => {
  const [firstColor, setFirstColor] = useState("#2b2d31")
  const [secondColor, setSecondColor] = useState("#2b2d31")
  const [currentDiv, setCurrentDiv] = useState("First")
  const [textColor1, setTextColor1] = useState("#eaeaeb")
  const [textColor2, setTextColor2] = useState("#eaeaeb")
  const rawRatio = useContrastRatio(firstColor, secondColor)

  const hexToRGB = (hex) => {
    try {
      hex = hex.replace('#', '')
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)
      
      return [
        isNaN(r) ? 0 : r,
        isNaN(g) ? 0 : g,
        isNaN(b) ? 0 : b
      ]

    } catch (error) {
      console.error('Invalid hex color:', hex)
      return [0, 0, 0]
    }
  }
  
  const handleColorChange = (e) => {
    if (currentDiv === "First") {
      setFirstColor(e.target.value)
    } else {
      setSecondColor(e.target.value)
    }
  }
  
  useEffect(() => {
    const first = hexToRGB(firstColor)
    const second = hexToRGB(secondColor)

    if (Number(first[0]) > 200 && Number(first[1]) > 200 && Number(first[2]) > 200) {
      setTextColor1("#000000")
    } else {
      setTextColor1("#ffffff")
    }
    if (Number(second[0]) > 200 && Number(second[1]) > 200 && Number(second[2]) > 200) {
      setTextColor2("#000000")
    } else {
      setTextColor2("#ffffff")
    }

  }, [firstColor, secondColor])

  return (
    <div className='color-contrast-page'>
      <h2>Color Contrast</h2>
      <main className='show-color-div'>
      <div className='input-div'>
        <label htmlFor="color-input-label">{currentDiv} Color:</label>
        <input type="color" name="color-picker" id="color-picker" value={currentDiv === "First" ? firstColor : secondColor} onChange={(e) => handleColorChange(e)}/>
      </div>
      <div className='display-container'>
        <div className='display-color first' style={{backgroundColor: `${firstColor}`, color: textColor1}} onClick={() => setCurrentDiv("First")}>
          <span className='ratio'>{rawRatio[0]}</span>
          <p>{(firstColor.toLowerCase() === "#2b2d31") && (secondColor.toLowerCase() === "#2b2d31") ? "Click to select" : ""}</p>
          <p>{firstColor.toUpperCase()}</p>
        </div>
        <div className='display-color second' style={{backgroundColor: `${secondColor}`, color: textColor2}} onClick={() => setCurrentDiv("Second")}>
          <span className='ratio'>{rawRatio[1]}</span>
          <p>{(firstColor.toLowerCase() === "#2b2d31") && (secondColor.toLowerCase() === "#2b2d31") ? "Click to select" : ""}</p>
          <p>{secondColor.toUpperCase()}</p>
        </div>
      </div>
      </main>
    </div>
  )
}

export default ColorContrast